import React from 'react';
import Header from './components/Header/Header';
import MainContent from './components/MainContent/MainContent';
import Footer from './components/Footer/Footer';
import './App.scss';

const App = () => {
	return (
		<div className="app">
			<Header />
			<MainContent />
			<Footer />
		</div>
	);
};

export default App;
